export interface IItemAttribute {
code: string;
label: string;
value: string;
iconUri: string;
hide: boolean;
description: string;
attrId?: string;
}
